import { render, staticRenderFns } from "./DocumentoExport.vue?vue&type=template&id=645b0031"
import script from "./DocumentoExport.vue?vue&type=script&lang=js"
export * from "./DocumentoExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports